export default "__VITE_PUBLIC_ASSET__a206e6ff__"